import React from 'react';
import { connect } from 'react-redux';

import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import Logo from '../../icons/Logo';

import './LoginFailedModal.scss';

class LoginFailedModal extends React.Component {
    render() {
        const { i18n, clubCardInactive } = this.props;

        return (
            <div className="login-failed">
                <Logo />
                <p className="content">
                    {convertHtmlToReactDomWithParams(
                        clubCardInactive ? i18n.CLUB_CARD_INACTIVE : i18n.LOGIN_FAILED
                    )}
                </p>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.login
    };
};

export default connect(mapStateToProps)(LoginFailedModal);



// WEBPACK FOOTER //
// ./src/components/authentication/login/LoginFailedModal.js